<template>
  <div class="retailers">
    <BannerImg :img-url="$StaticFileUrl + '/mp/BannerImage/cg_img_001.jpg'">
      <div class="title wow fadeInDown" data-wow-duration="1s">万鲸企业采购解决方案</div>
      <div class="desc wow fadeInDown" data-wow-duration="1s">通过电商化采购平台，将原本线下繁琐的采购工作简单化、信息化、透<br>明化，合理管控成本，有效提高效率</div>
      <div class="flex-row flex-col-center">
        <div class="btn-red wow flipInX" data-wow-duration="1s" style="margin-top: 100px">立即体验</div>
      </div>
    </BannerImg>
  </div>
</template>

<script>
import WOW from 'wowjs'
import BannerVideo from '@/components/BannerVideo'

/**
 * @author  XuHongli
 * @date  2022/12/28 10:12
 * @version 1.0
 * @description
 */
import BannerImg from '@/components/BannerImg'
export default {
  name: 'Retailers',
  components: {
    BannerImg,
  },
  mounted() {
    new WOW.WOW().init()
  }
}
</script>

<style scoped>

</style>
